import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SafeIcon from '../common/SafeIcon';
import SEOHead from '../components/SEOHead';
import * as FiIcons from 'react-icons/fi';

const {FiPhone,FiMail,FiMapPin,FiClock,FiSend,FiCheck,FiInfo,FiUser,FiHome}=FiIcons;

const ContactPage=()=> {
  const [formData,setFormData]=useState({
    fullName: '',
    telephone: '',
    email: '',
    postcode: '',
    message: ''
  });
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [isSubmitted,setIsSubmitted]=useState(false);

  const handleInputChange=(e)=> {
    const {name,value}=e.target;
    setFormData(prev=> ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit=async (e)=> {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Create FormData for Netlify
      const netlifyFormData=new FormData();
      netlifyFormData.append('form-name','contact');
      Object.keys(formData).forEach(key=> {
        netlifyFormData.append(key,formData[key]);
      });

      const response=await fetch('/',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(netlifyFormData).toString()
      });

      if (response.ok) {
        setIsSubmitted(true);
        // Reset form after 5 seconds
        setTimeout(()=> {
          setIsSubmitted(false);
          setFormData({
            fullName: '',
            telephone: '',
            email: '',
            postcode: '',
            message: ''
          });
        },5000);
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:',error);
      alert('There was an error submitting your form. Please try calling us directly at 07878 522378.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Contact Diamond Cleaning Aylesbury - Get Your Free Cleaning Quote"
        description="Contact Diamond Cleaning for professional cleaning services in Aylesbury. Free quotes, reliable service. Call 07878 522378 or email diamonddomesticcleaning1@gmail.com"
        image="https://diamondcleaning-aylesbury.com/img/logo.webp"
      />
      <Header currentArea="Aylesbury" />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-600 to-blue-800 pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Contact Diamond Cleaning
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
              Get in touch with our friendly team for a free quote or to discuss your cleaning requirements. We're here to help with all your domestic and commercial cleaning needs in Aylesbury and surrounding areas.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {/* Phone */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiPhone} className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Call Us</h3>
              <a href="tel:07878522378" 
                 className="text-2xl font-bold text-green-600 hover:text-green-700 transition-colors mb-2 block">
                07878 522378
              </a>
              <p className="text-gray-600">
                Speak directly with our team for immediate assistance and free quotes
              </p>
            </div>

            {/* Email */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiMail} className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Email Us</h3>
              <a href="mailto:diamonddomesticcleaning1@gmail.com" 
                 className="text-lg font-semibold text-blue-600 hover:text-blue-700 transition-colors mb-2 block">
                diamonddomesticcleaning1@gmail.com
              </a>
              <p className="text-gray-600">
                Send us your requirements and we'll respond within 24 hours
              </p>
            </div>

            {/* Address */}
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <SafeIcon icon={FiMapPin} className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Visit Us</h3>
              <address className="text-gray-700 not-italic mb-2">
                5 Ossulbury Lane<br />
                Aylesbury HP19 9DW<br />
                Buckinghamshire
              </address>
              <p className="text-gray-600">
                Our local office in the heart of Aylesbury
              </p>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="bg-white rounded-2xl p-8 shadow-lg max-w-md mx-auto text-center">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiClock} className="w-8 h-8 text-orange-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">Opening Hours</h3>
            <div className="text-gray-700 space-y-2">
              <div className="flex justify-between items-center">
                <span className="font-medium">Monday - Sunday</span>
                <span>9:00 AM - 8:00 PM</span>
              </div>
            </div>
            <p className="text-gray-600 mt-4 text-sm">
              Available 7 days a week for your convenience
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form and Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Contact Form */}
            <div className="bg-gray-50 rounded-2xl p-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-4">
                  Get Your Free Quote
                </h2>
                <p className="text-gray-600">
                  Fill out the form below and we'll get back to you with a personalized cleaning quote
                </p>
              </div>

              {isSubmitted ? (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <SafeIcon icon={FiCheck} className="w-8 h-8 text-green-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    Message Sent Successfully!
                  </h3>
                  <p className="text-gray-600 mb-6">
                    Thank you for contacting Diamond Cleaning. We'll get back to you within 24 hours.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a href="tel:07878522378" 
                       className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold text-center">
                      Call for Immediate Response
                    </a>
                  </div>
                </div>
              ) : (
                <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit} className="space-y-6">
                  {/* Hidden field for Netlify */}
                  <input type="hidden" name="form-name" value="contact" />

                  {/* Full Name */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <SafeIcon icon={FiUser} className="inline w-4 h-4 mr-2" />
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    />
                  </div>

                  {/* Telephone */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <SafeIcon icon={FiPhone} className="inline w-4 h-4 mr-2" />
                      Telephone Number *
                    </label>
                    <input
                      type="tel"
                      name="telephone"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      placeholder="e.g. 01296 123456"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    />
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <SafeIcon icon={FiMail} className="inline w-4 h-4 mr-2" />
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="your.email@example.com"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    />
                  </div>

                  {/* Postcode */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      <SafeIcon icon={FiMapPin} className="inline w-4 h-4 mr-2" />
                      Postcode *
                    </label>
                    <input
                      type="text"
                      name="postcode"
                      value={formData.postcode}
                      onChange={handleInputChange}
                      placeholder="e.g. HP20 2AB"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      required
                    />
                  </div>

                  {/* Message */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Message (Optional)
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows={5}
                      placeholder="Tell us about your cleaning requirements, property size, preferred frequency, or any specific needs..."
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-vertical"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                      The more details you provide, the more accurate quote we can give you
                    </p>
                  </div>

                  {/* Submit Button */}
                  <div className="pt-4">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className={`w-full py-4 px-6 rounded-lg font-semibold text-lg transition-colors flex items-center justify-center space-x-2 ${
                        isSubmitting
                          ? 'bg-gray-400 cursor-not-allowed'
                          : 'bg-blue-600 hover:bg-blue-700'
                      } text-white`}
                    >
                      <SafeIcon icon={FiSend} className="w-5 h-5" />
                      <span>{isSubmitting ? 'Sending...' : 'Send Message'}</span>
                    </button>
                  </div>

                  {/* Alternative Contact */}
                  <div className="text-center pt-6 border-t border-gray-200">
                    <p className="text-gray-600 mb-4">
                      Need immediate assistance?
                    </p>
                    <a href="tel:07878522378" 
                       className="inline-flex items-center space-x-2 bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold">
                      <SafeIcon icon={FiPhone} className="w-4 h-4" />
                      <span>Call: 07878 522378</span>
                    </a>
                  </div>
                </form>
              )}
            </div>

            {/* Map and Location Info */}
            <div className="space-y-8">
              {/* Interactive Map */}
              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Find Our Office
                </h3>
                {/* Embedded Google Map */}
                <div className="relative overflow-hidden rounded-xl shadow-lg mb-6" style={{paddingBottom: '56.25%',height: 0}}>
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.1234567890123!2d-0.8123456789012345!3d51.81234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNTHCsDQ4JzQ0LjQiTiAwwrA0OCc0NC40Ilc!5e0!3m2!1sen!2suk!4v1234567890123!5m2!1sen!2suk"
                    width="100%"
                    height="100%"
                    style={{position: 'absolute',top: 0,left: 0,border: 0}}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Diamond Cleaning Office Location"
                  ></iframe>
                </div>
                {/* Location Details */}
                <div className="text-center">
                  <div className="flex items-center justify-center space-x-2 mb-4">
                    <SafeIcon icon={FiMapPin} className="w-5 h-5 text-blue-600" />
                    <span className="text-lg font-semibold text-gray-900">Our Location</span>
                  </div>
                  <address className="text-gray-700 not-italic mb-4">
                    5 Ossulbury Lane<br />
                    Aylesbury HP19 9DW<br />
                    Buckinghamshire, England
                  </address>
                  <p className="text-gray-600 text-sm">
                    Conveniently located in Aylesbury with easy access to surrounding areas including Milton Keynes, Buckingham, and Princes Risborough.
                  </p>
                </div>
              </div>

              {/* Service Areas */}
              <div className="bg-blue-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Areas We Cover
                </h3>
                <div className="grid grid-cols-2 gap-4 text-center">
                  {[
                    'Aylesbury','Milton Keynes','Bletchley','Buckingham',
                    'Princes Risborough','Wendover','Haddenham','Long Crendon',
                    'Tingewick','Weston Turville','Woburn','And Surrounding Areas'
                  ].map((area,index)=> (
                    <div key={index} className="bg-white rounded-lg p-3 shadow-sm">
                      <span className="text-gray-700 font-medium">{area}</span>
                    </div>
                  ))}
                </div>
                <div className="text-center mt-6">
                  <p className="text-gray-600 mb-4">
                    Don't see your area? Give us a call - we may still be able to help!
                  </p>
                  <a href="tel:07878522378" 
                     className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-700 font-semibold">
                    <SafeIcon icon={FiPhone} className="w-4 h-4" />
                    <span>Check Coverage: 07878 522378</span>
                  </a>
                </div>
              </div>

              {/* Quick Links */}
              <div className="bg-gray-50 rounded-2xl p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
                  Quick Links
                </h3>
                <div className="space-y-4">
                  <Link to="/book" 
                        className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiHome} className="w-5 h-5 text-blue-600" />
                      <span className="font-medium text-gray-900">Book Online</span>
                    </div>
                    <span className="text-gray-400">→</span>
                  </Link>
                  <Link to="/domestic" 
                        className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiHome} className="w-5 h-5 text-green-600" />
                      <span className="font-medium text-gray-900">Domestic Services</span>
                    </div>
                    <span className="text-gray-400">→</span>
                  </Link>
                  <Link to="/commercial" 
                        className="flex items-center justify-between bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiUser} className="w-5 h-5 text-purple-600" />
                      <span className="font-medium text-gray-900">Commercial Services</span>
                    </div>
                    <span className="text-gray-400">→</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Enhanced FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-gray-600">
              Quick answers to common questions about our cleaning services
            </p>
          </div>

          <div className="space-y-6">
            {[
              {
                category: "General Services",
                questions: [
                  {
                    question: "How quickly can you provide a quote?",
                    answer: "We typically respond to online enquiries within 24 hours. For immediate quotes, please call us on 07878 522378 and we can provide an estimate over the phone."
                  },
                  {
                    question: "What areas do you cover?",
                    answer: "We cover Aylesbury and surrounding areas including Milton Keynes, Buckingham, Princes Risborough, Wendover, Haddenham, Long Crendon, Tingewick, Weston Turville, Woburn, and more. Call us to check if we service your specific location."
                  },
                  {
                    question: "Do you provide cleaning supplies and equipment?",
                    answer: "Yes, we bring all necessary cleaning supplies and professional equipment to every job. You don't need to worry about providing anything unless you have specific product preferences."
                  }
                ]
              },
              {
                category: "Booking & Pricing",
                questions: [
                  {
                    question: "How much do your cleaning services cost?",
                    answer: "Our standard rate is £18 per hour. The total cost depends on your property size, cleaning frequency, and specific requirements. We offer free quotes to give you an accurate price."
                  },
                  {
                    question: "Can I book a one-off cleaning service?",
                    answer: "Yes! We offer both regular cleaning services (weekly, fortnightly, monthly) and one-off cleans for deep cleaning, end of tenancy, or special occasions."
                  },
                  {
                    question: "How do I book your services?",
                    answer: "You can book online through our website, call us on 07878 522378, or email us at diamonddomesticcleaning1@gmail.com. We'll arrange a convenient time for your clean."
                  },
                  {
                    question: "Do you require a minimum number of hours?",
                    answer: "We typically have a 2-hour minimum for domestic cleans and 3-hour minimum for commercial services. This ensures we can provide a thorough and worthwhile service."
                  }
                ]
              },
              {
                category: "Service Details",
                questions: [
                  {
                    question: "Are your cleaners insured and vetted?",
                    answer: "Absolutely. All our cleaning staff are fully insured, background checked, and professionally trained to maintain the highest standards of cleaning and customer service."
                  },
                  {
                    question: "Do I need to be home during the cleaning?",
                    answer: "No, you don't need to be home. Many of our customers provide keys or access codes. We're fully insured and our cleaners are thoroughly vetted for your peace of mind."
                  },
                  {
                    question: "What happens if I'm not satisfied with the cleaning?",
                    answer: "Customer satisfaction is our priority. If you're not completely happy with our service, please contact us within 24 hours and we'll return to address any concerns at no extra charge."
                  },
                  {
                    question: "Can you clean around pets?",
                    answer: "Yes, we're happy to clean homes with pets. Please let us know about any pets when booking so our cleaners can take appropriate precautions and use pet-safe products if needed."
                  }
                ]
              },
              {
                category: "Scheduling & Cancellation",
                questions: [
                  {
                    question: "What are your working hours?",
                    answer: "We're available Monday to Sunday, 9:00 AM to 8:00 PM. We can often accommodate cleaning outside these hours for commercial clients or special circumstances."
                  },
                  {
                    question: "How much notice do you need for booking?",
                    answer: "We can often accommodate same-day or next-day bookings, subject to availability. For regular services, we recommend booking at least a week in advance to secure your preferred time slot."
                  },
                  {
                    question: "What's your cancellation policy?",
                    answer: "We require 24 hours' notice for cancellations. For regular services, we understand emergencies happen and we'll work with you to reschedule when possible."
                  },
                  {
                    question: "Do you work on weekends and holidays?",
                    answer: "Yes, we work 7 days a week including weekends. Holiday availability may vary, so please contact us in advance for holiday period bookings."
                  }
                ]
              },
              {
                category: "Specialized Services",
                questions: [
                  {
                    question: "Do you offer end of tenancy cleaning?",
                    answer: "Yes, we specialize in end of tenancy cleaning with a deposit-back guarantee. Our thorough service meets landlord and letting agent standards to help secure your deposit return."
                  },
                  {
                    question: "Can you clean commercial properties?",
                    answer: "Absolutely! We provide comprehensive commercial cleaning for offices, retail spaces, restaurants, communal areas, and more. We can work around your business hours to minimize disruption."
                  },
                  {
                    question: "Do you offer deep cleaning services?",
                    answer: "Yes, our deep cleaning service covers areas often missed in regular cleaning - inside ovens, cupboards, behind appliances, detailed bathroom cleaning, and much more."
                  },
                  // {
                  //   question: "Can you clean carpets and upholstery?",
                  //   answer: "We provide carpet cleaning as part of our deep cleaning and end of tenancy services. For specialized carpet or upholstery cleaning, please discuss your specific requirements when booking."
                  // }
                ]
              }
            ].map((category,categoryIndex)=> (
              <div key={categoryIndex} className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4 border-b-2 border-blue-600 pb-2">
                  {category.category}
                </h3>
                <div className="space-y-4">
                  {category.questions.map((faq,index)=> (
                    <div key={index} className="bg-white rounded-lg p-6 shadow-sm">
                      <h4 className="text-lg font-semibold text-gray-900 mb-3">
                        {faq.question}
                      </h4>
                      <p className="text-gray-600">
                        {faq.answer}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-gray-600 mb-6">
              Still have questions? We're here to help!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:07878522378" 
                 className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-semibold text-center">
                Call: 07878 522378
              </a>
              <a href="mailto:diamonddomesticcleaning1@gmail.com" 
                 className="bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors font-semibold text-center">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;